import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { submitApmcApproveRejectApplication } from '../../auth/services/privateapicalling';
import useSelection from 'antd/es/table/hooks/useSelection';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { formFieldDataP1, formFieldDataP2, formFieldDataP3 } from '../../../core/data/json/DistrictAPMC';

const JCForwardForm: React.FC = () => {

   const token = useSelector((state:any)=>state.auth.token)
   const location = useLocation();
  const comment= location.state?.comment || '';
   const existData = location.state?.existData;
   const applicationId = location.state?.applicationId;
   const navigate = useNavigate()
 const [issued, setIssued] = useState(false);
 const [agree, setAgree] = useState(false);
     const userDetail = useSelector((state:any)=>state.auth.userDetails)
  const roleIdentifier = userDetail.Role.Role_Identifier;

   

   
   const apmcName = existData?.annexureOne?.apmc?.data.find(data=>data.fieldName == "apmcName")?.value;
   const scheme =   existData?.scheme?.name;
   const allYards = [...existData?.subYard, ...existData?.mainYard];
 const assistanceDetails = existData?.annexureOne?.estimateProjectCost?.data[1]?.value
 const amounttotal = existData?.annexureOnePointOne?.newData?.data?.estimateProjectCostAmount
// Extract unique purpose names

   const purpose = allYards
     .map(item => item.purpose)
     .filter((value, index, self) => self.indexOf(value) === index)
     .join(', ');

   const numberToWords = (numStr: string): string => {
  // Remove any commas and trim whitespace
  numStr = numStr.replace(/,/g, '').trim();
  
  // Validate input
  // if (!/^\d+$/.test(numStr)) {
  //   return "Invalid input: Please provide a valid number string";
  // }
  
  const num = parseInt(numStr);
  
  // Check if number is within range
  if (num > 50000000) {
    return "Number exceeds 5 crore limit";
  }
  
  if (num === 0) {
    return "Zero";
  }
  
  // Arrays for number words
  const ones: string[] = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens: string[] = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", 
                 "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens: string[] = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  
  // Helper function to convert numbers less than 100
  const convertTens = (n: number): string => {
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
  };
  
  // Helper function to convert numbers less than 1000
  const convertHundreds = (n: number): string => {
    if (n < 100) return convertTens(n);
    return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convertTens(n % 100) : "");
  };
  
  let result = "";
  
  // Crore (10,000,000)
  if (num >= 10000000) {
    const crore = Math.floor(num / 10000000);
    result += convertHundreds(crore) + " Crore ";
  }
  
  // Lakh (100,000)
  const remaining = num % 10000000;
  if (remaining >= 100000) {
    const lakh = Math.floor(remaining / 100000);
    result += convertTens(lakh) + " Lakh ";
  }
  
  // Thousand (1,000)
  const remaining2 = remaining % 100000;
  if (remaining2 >= 1000) {
    const thousand = Math.floor(remaining2 / 1000);
    result += convertTens(thousand) + " Thousand ";
  }
  
  // Hundred (100)
  const remaining3 = remaining2 % 1000;
  if (remaining3 >= 100) {
    const hundred = Math.floor(remaining3 / 100);
    result += ones[hundred] + " Hundred ";
  }
  
  // Last two digits
  const lastTwo = remaining3 % 100;
  if (lastTwo > 0) {
    result += convertTens(lastTwo);
  }
  
  return result.trim();
};
 const totalSanctionedAmount = useMemo(() => {
  
  if (!assistanceDetails || !Array.isArray(assistanceDetails)) return 0;
  
  return assistanceDetails.reduce((sum: number, item: any) => {
    const cost = item?.cost ?? 0;
    const n = typeof cost === 'number' ? cost : parseFloat(cost);
    return sum + (isNaN(n) ? 0 : n);
  }, 0);
}, [assistanceDetails]);

const formattedTotalSanctioned = totalSanctionedAmount > 0 
  ? totalSanctionedAmount.toLocaleString('en-IN') 
  : "";
  const totalAmount = useMemo(() => {

  if (!amounttotal || !Array.isArray(amounttotal)) return 0;
  
  return amounttotal.reduce((sum: number, item: any) => {
    const cost = item?.eligibleCost ?? 0;
    const n = typeof cost === 'number' ? cost : parseFloat(cost);
    return sum + (isNaN(n) ? 0 : n);
  }, 0);
}, [amounttotal]);

const formattedTotal = totalAmount > 0 
  ? totalAmount.toLocaleString('en-IN') 
  : "";
useEffect(() => {
  if (roleIdentifier === "SC" || roleIdentifier === "HOS" || roleIdentifier === "DT" || roleIdentifier === "DY"||roleIdentifier==="SA" ) {
    setIssued(true);
    
   setJcForm({
    field1: existData?.categoryName || '',
    field2: existData?.totalProjectCost || '',
    field3: existData?.amount || '',
    field4: existData?.percentageApproval || '',
    field5: '',
    field6: '',
    field7: ''
    });
  

  }
}, [roleIdentifier]);

  const [jcForm, setJcForm] = useState({
      field1: existData?.annexureOne?.certOfMarketCommitteCategory?.data[0]?.value || '',
    field2: String(formattedTotalSanctioned) || '',
    field3: String(formattedTotal) || '',
    field4: existData?.annexureOne?.percentOfProjCostEligible?.data[0]?.value || '',
    field5: '', // Project Cost (In Words)
    field6: '', // Eligible Percentage
    field7: '', // Eligible Percentage
  });
  
// const areAllFieldsVerified = () => {
//   // Check formFieldDataP1 (skip '01.', '02.', and '03.')
//   const isP1Verified = formFieldDataP1.every((item, index) => {
//     if (item.fieldNo === '01.' || item.fieldNo === '02.' || item.fieldNo === '03.') {
//       return true;
//     }

//     const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
//     const transactions = existData?.annexureOne?.[fieldName]?.transaction ?? [];
    
//     // Find the last transaction for this role and status
//     const lastTransaction = [...transactions]
//       .reverse()
//       .find(
//         (txn) => 
//           txn?.transactionBy === roleIdentifier && 
//           txn.status === existData.status
//       );
// console.log("Last Transaction for field", fieldName, ":", lastTransaction);
//     // Check if the last transaction is verified
//     const isFieldVerified = lastTransaction?.isVerified === true;

//     return isFieldVerified;
//   });

//   // Check formFieldDataP2
//   const isP2Verified = formFieldDataP2.every((item, index) => {
//     const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
//     const transactions = existData?.annexureTwo?.[fieldName]?.transaction ?? [];
    
//     const lastTransaction = [...transactions]
//       .reverse()
//       .find(
//         (txn) => 
//           txn?.transactionBy === roleIdentifier && 
//           txn.status === existData.status
//       );
// console.log("Last Transaction for field", fieldName, ":", lastTransaction);
//     const isFieldVerified = lastTransaction?.isVerified === true;

//     return isFieldVerified;
//   });

//   // Check formFieldDataP3
//   const isP3Verified = formFieldDataP3.every((item, index) => {
//     const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
//     const transactions = existData?.annexureThree?.[fieldName]?.transaction ?? [];
    
//     const lastTransaction = [...transactions]
//       .reverse()
//       .find(
//         (txn) => 
//           txn?.transactionBy === roleIdentifier && 
//           txn.status === existData.status
//       );
// console.log("Last Transaction for field", fieldName, ":", lastTransaction);
//     const isFieldVerified = lastTransaction?.isVerified === true;

//     return isFieldVerified;
//   });


//   return isP1Verified && isP2Verified && isP3Verified;
// };

const areAllFieldsVerified = () => {
  // Check formFieldDataP1 (skip '01.', '02.', and '03.')
  const isP1Verified = formFieldDataP1.every((item, index) => {
    if (item.fieldNo === '01.' || item.fieldNo === '02.' || item.fieldNo === '03.') {
      return true;
    }

    const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
    const transactions = existData?.annexureOne?.[fieldName]?.transaction ?? [];
    
    const lastTransaction = [...transactions]
      .reverse()
      .find(
        (txn) => 
          txn?.transactionBy === roleIdentifier 
      );
    
   
    
    // If lastTransaction is undefined, consider it verified (true)
    const isFieldVerified = lastTransaction?.isVerified ?? true;

    return isFieldVerified;
  });

  // Check formFieldDataP2
  const isP2Verified = formFieldDataP2.every((item, index) => {
    const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
    const transactions = existData?.annexureTwo?.[fieldName]?.transaction ?? [];
    
    const lastTransaction = [...transactions]
      .reverse()
      .find(
        (txn) => 
          txn?.transactionBy === roleIdentifier 
      );
    
 
    
    // If lastTransaction is undefined, consider it verified (true)
    const isFieldVerified = lastTransaction?.isVerified ?? true;

    return isFieldVerified;
  });

  // Check formFieldDataP3
  const isP3Verified = formFieldDataP3.every((item, index) => {
    const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
    const transactions = existData?.annexureThree?.[fieldName]?.transaction ?? [];
    
    const lastTransaction = [...transactions]
      .reverse()
      .find(
        (txn) => 
          txn?.transactionBy === roleIdentifier 
      );
    
    
    // If lastTransaction is undefined, consider it verified (true)
    const isFieldVerified = lastTransaction?.isVerified ?? true;

    return isFieldVerified;
  });

  return isP1Verified && isP2Verified && isP3Verified;
};
 

  const handleBack=()=>{
    navigate(-1);
  }

   const handleFinalSubmit = async (status , appStatusLevel)=>{
      try {
        if(roleIdentifier === "Dr" && !agree && status !=="reject"){
          toast.error("Please agree to the terms before submitting.", {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" },
          });
          return;
        }

          if ((["Dr", "DT", "DY","SC"].includes(roleIdentifier) && status === "reject") || (roleIdentifier === "DT" && status === "permanentReject")) {
              const allVerified = areAllFieldsVerified();
             
                if (allVerified) {
                  if (status === "reject") {
                    toast.error("All fields are verified. You cannot raise a query.", {
                      position: "top-right",
                      style: { fontSize: "1.2rem", padding: "16px" },
                    });
                  } else {
                    toast.error("All fields are verified. You cannot permanently reject.", {
                      position: "top-right",
                      style: { fontSize: "1.2rem", padding: "16px" },
                    });
                  }
                  return;
                }
              }
        const formData = {
        status: status,
        appStatusLevel: appStatusLevel,
        applicationId: applicationId,
        schemeId:existData?.scheme?.id,
        applicationType: "scheme",
        comment: comment,
          ...((roleIdentifier === "Dr") && {
    categoryName:jcForm.field1,
    totalProjectCost:jcForm.field2,
    amount:jcForm.field3,
    amountInWords:numberToWords(jcForm.field3),
 percentageApproval:jcForm.field4,
  }),
  
      };
  
  
       const submitData = await submitApmcApproveRejectApplication(
                formData,
                token
              );
              //.log("Submitted Data Response:", submitData);
      
              if (submitData.success) {
                if (submitData?.data?.status === "reject") {
                  // alert("Raised-Query successfully!");
                  toast.warning("Raised-Query successfully!", { position: "top-right", autoClose: 5000 });

                }
                else if(submitData?.data?.status === "permanentReject"){
                  // alert("Application permanently rejected!");
                  toast.warning("Application Permanently Rejected!", { position: "top-right", autoClose: 5000 });

                } else if(submitData?.data?.status === "approvedUnsigned"){
                  // alert("Application Approved!");
                  toast.success("Application Approved!", { position: "top-right", autoClose: 5000 });

                } else {
                  // alert("Form submitted successfully!");
                  toast.success("Form submitted successfully!", { position: "top-right", autoClose: 5000 });
                  
                }
                // setButtonData([]);
                // fetchApplicationDetails(applicationId);
                  setTimeout(() => {
                        navigate("/apmc-application");
                    }, 2000);
              } else {
                // alert("Submission failed, please try again.");
                toast.error("Submission failed, please try again!", { position: "top-right", autoClose: 5000 });
              }
  
      } catch (error) {
      
      }
    }

  return (
<>
  <div className="page-wrapper">
    <div className="d-flex flex-column text-nightblue mt-4">
      <h1 className="ms-4 mb-4">
        Application for Scheme - પરિશિષ્ટ:-૩ પ્રમાણપત્ર(Annexure:-3 Certificate)
      </h1>

      <div className="d-flex justify-content-center">
        {/* Wrapper Div with Flex Row */}
        <div className="w-75 d-flex flex-row align-items-start gap-3 border bg-white border-secondary rounded mb-5 p-3">
          
          {/* Left Side - Checkbox */}
          <div className="pt-2">
   {  !issued &&      <input
              className="form-check-input"
              type="checkbox"
              name="agreeTerms"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
              id="agreeTerms"
              style={{ transform: 'scale(1.5)' }}
            />}
          </div>

          {/* Right Side - Form + Button */}
          <div className="flex-grow-1"> 
            <div className="p-2 rounded">
              <p>
                આથી પ્રમાણિત કરવામાં આવે છે કે, ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
                <strong>{apmcName || '_______________'}</strong> ની વરહઃ<strong>&nbsp; {scheme} </strong>: બજાર સમિતિઓમાં આધુનિકરણ તેમજ પાયાની સગવડો ઉભી કરવા સહાય આપવાની યોજના હેઠળ
                <strong>&nbsp;{purpose || '______________________________'}</strong> ના હેતુઓ માટેની સગવડો ઉભી કરવાની દરખાસ્ત અત્રેની કચેરીને મળેલ છે.
              </p>
              <p>
                જેમાં અરજીમાં દર્શાવેલ તમામ કોલમોની વિગતની ચકાસણી કરતાં, તે સાચી અને ખરી માલુમ પડેલ છે અને તેની વિગતો અત્રેની કચેરીમાં રાખવામાં આવેલ છે.
              </p>
              <p>
                દરખાસ્તમાં દર્શાવેલ પ્રોજેકટ, બજાર સમિતિ
                <strong>  <input
                type="text"
                value={jcForm?.field1}
                onChange={(e) =>setJcForm({...jcForm, field1: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              /></strong> વર્ગ ધરાવતી હોઇ, પ્રોજેકટ કિંમત રૂ.
                <strong> <input
                type="text"
                value={jcForm?.field2}
                onChange={(e) =>setJcForm({...jcForm, field2: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              /></strong> ના
                <strong><input
                type="text"
                value={jcForm?.field4}
                onChange={(e) =>setJcForm({...jcForm, field4: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              /></strong> ટકા મુજબ રૂ.
                <strong> <input
                type="text"
                value={jcForm?.field3}
                onChange={(e) =>setJcForm({...jcForm, field3: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              /></strong> (અંકે રૂપિયા
                <strong>{numberToWords(jcForm.field3) || '______________________________________'}</strong>) પૂરા સહાય મંજૂર કરવાપાત્ર થાય છે અને તે મંજૂર કરવા માટે ભલામણ છે.
              </p>

              <hr />

              <p>
                (This is to certify that the Agricultural Produce Market Committee,
                <strong> {apmcName || '_______________'}</strong> has submitted a proposal to this office under the<strong>{scheme}</strong>  : A scheme to provide assistance for modernization and development of basic infrastructure in Market Committees, for the purpose of setting up facilities for <strong>{purpose}</strong>. Upon verification of all the columns mentioned in the application, the details are found to be true and accurate, and the same have been retained in this office. The project proposed in the application belongs to a Market Committee of
                <strong>   <input
                type="text"
                value={jcForm?.field1}
                onChange={(e) =>setJcForm({...jcForm, field1: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              /></strong> class. Based on the project cost of Rs.
                <strong>   <input
                type="text"
                value={jcForm?.field2}
                onChange={(e) =>setJcForm({...jcForm, field2: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              /></strong>, assistance of Rs.
                <strong>   <input
                type="text"
                value={jcForm?.field3}
                onChange={(e) =>setJcForm({...jcForm, field3: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              /></strong> (in words:
                <strong> {numberToWords(jcForm?.field3) || '______________________________________'}</strong> rupees) at the rate of
                <strong> <input
                type="text"
                value={jcForm?.field4}
                onChange={(e) =>setJcForm({...jcForm, field4: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              /></strong>% is eligible for approval, and its approval is hereby recommended.)
              </p>

              {/* ✅ Button inside the right side */}
               <div className="d-flex justify-center justify-item-center py-4 w-100">
            <button className="btn btn-secondary me-2" onClick={handleBack}>Back</button>
                      {existData?.buttonName  &&
                        existData.buttonName.length > 0 &&
                        existData.buttonName[0].appStatusLevel != "licenseGranted" &&
                        existData.role !== "" && 
                        roleIdentifier === existData.role && (
                          <div className="row">
                           { 
                           !((["JC"].includes(existData.role) && existData.appStatusLevel=="dclerkAfterRejectionAction") || (["HJC"].includes(existData.role) && existData.appStatusLevel=="hoclerkAfterRejectionAction")) && 
                           <div>
                            {/* <textarea
                              className="form-control mb-2"
                              placeholder="Enter your comment"
                              name="currAt"
                              value={finalComment}
                              onChange={(e) => setFinalComment(e.target.value)}
                              rows={4}
                              maxLength={100}
                            /> */}

                            {/* {errorr && (
                              <div className="text-danger mb-2">{errorr}</div>
                            )} */}

                            {/* {errorr.comment && <p style={{ color: "red" }}>{errorr.comment}</p>} */}

                            </div>
                            }
                    

    <div className="d-flex gap-2">
  {existData?.buttonName
    ?.filter((button) => {
      // Apply skipping ONLY for this app status
      if (existData?.appStatusLevel === "pendingAtHigherAuthorityApproval") {
        // ❌ skip these buttons
        if (
          button?.appStatusLevel === "schemeGranted" ||
          button?.appStatusLevel === "applicationRejected"
        ) {
          return false;
        }
      }

      // ✅ show all other buttons
      return true;
    })
    .map((button) => (
      <button
        key={button.status}
        className={`btn ${
          button.status === "reject"
            ? "btn-danger"
            : button.status === "permanentReject"
            ? "btn-secondary"
            : "btn-success"
        } h-10 w-70`}
        onClick={() =>
          handleFinalSubmit(button.status, button.appStatusLevel)
        }
      >
        {button.buttonLabel}
      </button>
    ))}
</div>


                          </div>
                        )}
                    </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <ToastContainer position="top-right" autoClose={5000} />
</>

  );
};

export default JCForwardForm;
